import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { MetricMap, MetricResultQuery } from '@domains/metric'
import { Observable } from 'rxjs'
import { environment } from '@env'
import { MatchPlayerComparison, Player } from '@domains/player'
import { MatchPlayerComparisonQuery } from '@features/match-player/match-player.models'
import { withApiVersion } from '@system/application/api-version.interceptor'
import { SpaceMetric } from '@domains/space'

@Injectable()
export class MatchPlayerApi {
  private readonly _http: HttpClient = inject(HttpClient)

  fetchChartMetrics(query: MetricResultQuery): Observable<MetricMap> {
    const { playerId, teamId, seasonId, competitionId, positions } = query
    return this._http.get<MetricMap>(
      environment.api.playersMetricResults(seasonId, competitionId, teamId, playerId),
      { params: { playerPosition: positions[0] }, context: withApiVersion() },
    )
  }

  fetchMetrics(query: MetricResultQuery): Observable<SpaceMetric[]> {
    return this._http.post<SpaceMetric[]>(environment.api.widgets.base, {
      ...query,
      includeSeasonCompetition: true,
    })
  }

  fetchMatchPlayer(query: MetricResultQuery): Observable<Player> {
    const { playerId, teamId, seasonId, competitionId, matchId, positions } = query
    return this._http.get<Player>(
      environment.api.matchPlayerById(seasonId, competitionId, matchId, teamId, playerId),
      {
        params: { playerPosition: positions[0] },
        context: withApiVersion(),
      },
    )
  }

  fetchPlayer(query: MetricResultQuery): Observable<Player> {
    const { playerId, teamId, seasonId, competitionId } = query
    return this._http.get<Player>(
      environment.api.players(seasonId, competitionId, teamId, playerId),
    )
  }

  fetchMatchPlayerComparison(
    comparisonQuery: MatchPlayerComparisonQuery,
  ): Observable<MatchPlayerComparison> {
    return this._http.post<MatchPlayerComparison>(
      environment.api.matchPlayersCompare(comparisonQuery.playerA.matchId),
      comparisonQuery,
      { context: withApiVersion() },
    )
  }

  fetchPlayerComparison(
    comparisonQuery: MatchPlayerComparisonQuery,
  ): Observable<MatchPlayerComparison> {
    return this._http.post<MatchPlayerComparison>(environment.api.playersCompare, comparisonQuery, {
      context: withApiVersion(),
    })
  }
}
